import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {NolimitPlugin} from "@nolimitcity/slot-launcher/bin/NolimitPlugin";
import {GameModelEvent} from "@nolimitcity/slot-game/bin/model/GameModel";
import {Logger, LogLevel} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {GameFlowController} from "@nolimitcity/slot-game/bin/flowcontrol/GameFlowController";
import {FlowState} from "@nolimitcity/slot-game/bin/flowcontrol/FlowState";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FontLoader} from "@nolimitcity/slot-launcher/bin/loader/FontLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {AssetsConfig} from "@nolimitcity/slot-game/bin/asset/AssetsConfig";
import {AssetLoader} from "@nolimitcity/slot-game/bin/asset/AssetLoader";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/asset/ResourcesGroupName";
import {HTHGameAssets} from "./HTHGameAssets";
import {HTHSound} from "./sound/HTHSound";
import {HTHBackgroundElements} from "./view/HTHBackgroundElements";
import {HTHWinPresentation} from "./gameflow/HTHWinPresentation";
import {HTHNormalBetPresentation} from "./gameflow/HTHNormalBetPresentation";
import {HTHNormalResultPresentation} from "./gameflow/HTHNormalResultPresentation";
import {HTHNormalIdlePresentation} from "./gameflow/HTHNormalIdlePresentation";
import {HTHZeroBetIdlePresentation} from "./gameflow/HTHZeroBetIdlePresentation";
import {IHTHGameData, ISymbolValues} from "./server/HTHData";
import {HTHModel} from "./server/HTHModel";
import {HTHGameMode} from "./server/HTHGameMode";
import {HTHAvalancheIdlePresentation} from "./gameflow/HTHAvalancheIdlePresentation";
import {HTHReelArea} from "./reels/HTHReelArea";
import {HTHSymbolAnimation} from "./view/HTHSymbolAnimation";
import {HTHGameView} from "./view/HTHGameView";
import {HTHIndividualWinTextView} from "./view/HTHIndividualWinTextView";
import {HTHTotalWinView} from "./view/HTHTotalWinView";
import {TemplateAsset, TemplateLoader} from "@nolimitcity/slot-launcher/bin/loader/TemplateLoader";
import {HTHBigWinView} from "./view/HTHBigWinView";
import {RestoreUtils} from "./utils/RestoreUtils";
import {HTHFSOutro} from "./view/HTHFSOutro";
import {HTHFSIntro} from "./view/HTHFSIntro";
import {HTHReelAnticipation} from "./view/HTHReelAnticipation";
import {HTHWinCap} from "./view/HTHWinCap";
import {HTHSymbolOverlay} from "./view/HTHSymbolOverlay";
import {TransitionScreen} from "./view/TransitionScreen";
import {ReelFrameElements} from "./view/ReelFrameElements";
import {SpineViewUtils} from "./utils/SpineViewUtils";
import {MiniPayTable} from "./view/MiniPayTable";
import {Speedster} from "./utils/Speedster";
import {NolimitConfig} from "@nolimitcity/slot-launcher/bin/settings/NolimitConfig";
import {HTHExtraSpinIdle} from "./presentations/HTHExtraSpinIdle";
import {ExtraSpinView} from "./components/ExtraSpinView";
import {ScreenInteractiveLayer} from "./view/ScreenInteractiveLayer";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {AdditionalLayers} from "./view/AdditionalLayers";
import {FSGainedView} from "./view/FSGainedView";
import {
    BonusFeatureDisplayConfigurationList
} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetFeatureController";
import {BonusBuyPopUpContent} from "@nolimitcity/promo-panel/bin/feature/generic/BonusBuyPopUpContent";
import {Label} from "@nolimitcity/slot-launcher/bin/gui/labels/Label";
import {HTHReelAnticipationTop} from "./view/HTHReelAnticipationTop";
import {Skinner} from "@nolimitcity/slot-launcher/bin/utils/Skinner";
import {HTHGameIntroView} from "./intro/HTHGameIntroView";


export class HTH extends SlotGame {
    public static model: HTHModel;
    public static assetLoader: AssetLoader;
    public static soundPlayer: HTHSound;
    public static backgroundElements: HTHBackgroundElements;
    public static gameFlowController: GameFlowController;
    public static reelArea: HTHReelArea;
    public static symbolAnimation: HTHSymbolAnimation;
    public static gameViewContainer: HTHGameView;
    public static individualWinTextView: HTHIndividualWinTextView;
    public static totalWinView: HTHTotalWinView;
    public static bigWinView: HTHBigWinView;
    public static fsIntroView: HTHFSIntro;
    public static fsOutroView: HTHFSOutro;
    public static reelAnticipation: HTHReelAnticipation;
    public static reelAnticipationTop: HTHReelAnticipationTop;
    public static winCapView: HTHWinCap;
    public static symbolOverlay: HTHSymbolOverlay;
    public static transitionView: TransitionScreen;
    public static miniPayTable: MiniPayTable;
    public static extraSpinBet: ExtraSpinView;
    public static screenInteractive: ScreenInteractiveLayer;
    public static additionalLayers: AdditionalLayers;
    public static fsGainedView: FSGainedView;
    public static gameIntroView: HTHGameIntroView;
    public static rtpData: any;
    private skinner: Skinner;

    private _defaultSymbolValues: ISymbolValues = {
        "L1": {"3": 2, "4": 3, "5": 5, "6": 12},
        "L2": {"3": 2, "4": 3, "5": 5, "6": 10},
        "L3": {"3": 2, "4": 3, "5": 4, "6": 8},
        "L4": {"3": 2, "4": 3, "5": 4, "6": 7},
        "L5": {"3": 2, "4": 3, "5": 4, "6": 6},
        "M1": {"3": 6, "4": 10, "5": 15, "6": 40},
        "M2": {"3": 4, "4": 7, "5": 10, "6": 30},
        "M3": {"3": 3, "4": 5, "5": 8, "6": 24},
        "M4": {"3": 3, "4": 5, "5": 8, "6": 22},
        "M5": {"3": 3, "4": 5, "5": 8, "6": 20},
        "W": {"3": 0, "4": 0, "5": 0, "6": 40}
    }

    constructor() {
        super();
        this.skinner = new Skinner(["sweep"]);
    }

    private static getSymbolString(key: string, data: { [numSymbols: number]: number }): string {
        return `
            <div class="symbol">
            <img src="{{gamePath}}screens/images/symbols/${key}.png">
            <div class="payout-group">
            
                <div class="payout">
                    <span style="margin-left: 1.38em ;padding-right:1em" class="number">6</span>
                    <span style="margin-left: 0.1em" class="multiplier" data-multiplier="${data[6] * 0.05}">${data[6] * 0.05}</span>
                </div>
                <div class="payout">
                    <span style="margin-left: 1.38em ;padding-right:1em" class="number">5</span>
                    <span style="margin-left: 0.1em" class="multiplier" data-multiplier="${data[5] * 0.05}">${data[5] * 0.05}</span>
                </div>
                <div class="payout">
                    <span style="margin-left: 1.38em ;padding-right:1em" class="number">4</span>
                    <span style="margin-left: 0.1em" class="multiplier" data-multiplier="${data[4] * 0.05}">${data[4] * 0.05}</span>
                </div>
                <div class="payout">
                    <span style="margin-left: 1.38em ;padding-right:1em" class="number">3</span>
                    <span style="margin-left: 0.1em" class="multiplier" data-multiplier="${data[3] * 0.05}">${data[3] * 0.05}</span>
                </div>
            </div>
            </div>
        `;
    }

    public getPaytable(): Promise<string> {
        const templateLoader: TemplateLoader = new TemplateLoader(HTH.apiPlugin.resources.getStaticRoot());

        templateLoader.add({
            name: "Paytable", url: "nolimit/screens/paytable.mustache"
        });

        let symbolDataValueData: ISymbolValues = this._defaultSymbolValues;
        if (HTH.model.initData.symbolValues) {
            symbolDataValueData = HTH.model.initData.symbolValues;
            Logger.logDev("Using symbolValues from INIT data");
        } else {
            Logger.logDev("Using default symbolValues");
        }

        const promise: Promise<string> = templateLoader.load().then((assets: TemplateAsset[]) => {
            for (let asset of assets) {
                if (asset.name === "Paytable" && asset.loadedData) {
                    for (let key in symbolDataValueData) {
                        asset.loadedData = asset.loadedData.replace(`{{${key}}}`, HTH.getSymbolString(key, symbolDataValueData[key]))
                    }

                    const data: any = {
                        extraSpinAllowed: HTH.apiPlugin.gameClientConfiguration.extraSpinAllowed,
                        replaceWincapInfo: HTH.apiPlugin.gameClientConfiguration.replaceWincapInfo,
                        showLowProbabilityGfx: HTH.apiPlugin.gameClientConfiguration.showLowProbabilityGfx

                    }

                    let translatedContent: string = HTH.apiPlugin.translations.render(asset.loadedData, data);
                    translatedContent = translatedContent.replace(new RegExp("GOD_MODE_VALUE", "g"), (HTH.apiPlugin.betFeatureController.isFeatureAllowed("GOD_MODE") ? HTH.apiPlugin.betFeatureController.getFeatureData("GOD_MODE")!.price.toString() : ""));
                    translatedContent = translatedContent.replace(new RegExp("BOOSTED_BET_BONUS_HUNT_VALUE", "g"), (HTH.apiPlugin.betFeatureController.isFeatureAllowed("BOOSTED_BET_BONUS_HUNT") ? HTH.apiPlugin.betFeatureController.getFeatureData("BOOSTED_BET_BONUS_HUNT")!.price.toString() : ""));
                    translatedContent = translatedContent.replace(new RegExp("BOOSTED_BET_VALUE", "g"), (HTH.apiPlugin.betFeatureController.isFeatureAllowed("BOOSTED_BET") ? HTH.apiPlugin.betFeatureController.getFeatureData("BOOSTED_BET")!.price.toString() : ""));

                    return translatedContent;
                }
            }
            throw new Error("Game could not load Paytable");
        }) as Promise<string>;
        return promise;
    }

    public getGameRules(): Promise<string> {
        return super.getGameRules().then((value: string) => {
            const data: any = {
                replaceWincapInfo: HTH.apiPlugin.gameClientConfiguration.replaceWincapInfo,
                showLowProbabilityGfx: HTH.apiPlugin.gameClientConfiguration.showLowProbabilityGfx,
                showBaseGameHighestWinInRules: HTH.apiPlugin.gameClientConfiguration.showBaseGameHighestWinInRules,
                replaceSlotsInGameRules: HTH.apiPlugin.gameClientConfiguration.replaceSlotsInGameRules
            }
            value = value.replace(new RegExp("#actionSpinsAllowed", "g"), (HTH.apiPlugin.gameClientConfiguration.actionSpin ? "" : "actionSpinsNotAllowed"));

            let translatedContent: string = HTH.apiPlugin.translations.render(value, data);
            translatedContent = translatedContent.replace(new RegExp("#gambleGameRoundCloseIntervalHours", "g"), (HTH.apiPlugin.gameClientConfiguration.extraSpinAllowed ? HTH.apiPlugin.gameClientConfiguration.gambleGameRoundCloseIntervalHours.toString() : ""));
            return translatedContent;
        });
    }

    public getNolimitBonusDisplayConfiguration(): BonusFeatureDisplayConfigurationList {
        return {
            BOOSTED_BET: {
                displayName: "BOOSTED_BET",
                displayOrder: 0,
            },
            BOOSTED_BET_BONUS_HUNT: {
                displayName: "BOOSTED_BET_BONUS_HUNT",
                displayOrder: 1,
            },
            FREESPINS_0_SAFE: {
                displayName: "FREESPINS_0_SAFE",
                displayOrder: 2,
            },
            FREESPINS_1_SAFE: {
                displayName: "FREESPINS_1_SAFE",
                displayOrder: 3,
            },
            FREESPINS_2_SAFE: {
                displayName: "FREESPINS_2_SAFE",
                displayOrder: 4,
            },
            FREESPINS_3_SAFE: {
                displayName: "FREESPINS_3_SAFE",
                displayOrder: 5,
            },
            LUCKY_DRAW: {
                displayName: "LUCKY_DRAW",
                displayOrder: 6,
            },
            GOD_MODE: {
                displayName: "GOD_MODE",
                displayOrder: 7,
                replacePopUpContent: (content: BonusBuyPopUpContent) => {
                    const warningText: Label = new Label(HTH.apiPlugin.translations.translate("Warning: 1 spin!"), content.textLabel.getStyleClone());

                    warningText.scale.set(0.7);
                    warningText.anchor.set(0.5);
                    warningText.position.set(0, 400);
                    content.addChild(warningText);

                    content.textLabel.scale.set(0.8);
                    content.textLabel.position.y -= 30;

                    return content;
                }
            }
        }
    }

    public getNoWinGameData(): any {
        return {
            "reels": [["M2", "M1", "L2", "L3"], ["M3", "L2", "L3", "EB"], ["L1", "M2", "SC", "EB"], ["L2", "M1", "L4", "EB"], ["M2", "M3", "L3", "EB"], ["L1", "L2", "M4", "L1"]],
            "evaluatedReels": [["M2", "M1", "L2", "L3"], ["M3", "L2", "L3", "EB"], ["L1", "M2", "SC", "EB"], ["L2", "M1", "L4", "EB"], ["M2", "M3", "L3", "EB"], ["L1", "L2", "M4", "L1"]],
            "betWayWins": [],
            "playedBetValue": 1,
            "win": 0,
            "accumulatedRoundWin": 0,
            "fsRoundWin": 0,
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "wasFeatureBuy": false,
            "boostedBet": false,
            "brokeTheBank": false,
            "freespinsPlayed": 0,
            "freespinsLeft": 0,
            "serverTestInfo": {},
            "sizes": [[1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1]],
            "evaluatedSizes": [[1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1]],
            "spinWin": 0,
            "reelsAfterAvalanche": [["M2", "M1", "L2", "L3"], ["M3", "L2", "L3", "EB"], ["L1", "M2", "SC", "EB"], ["L2", "M1", "L4", "EB"], ["M2", "M3", "L3", "EB"], ["L1", "L2", "M4", "L1"]],
            "sizesAfterAvalanche": [[1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1]],
            "safeSymbols": [],
            "enhancerBlocks": ["XW", "M5", "M2", "W"],
            "xNudgeMultipliers": [0, 0, 0, 0, 0, 0],
            "increaseMultiplierCoordinates": [],
            "removalSymbolTargets": [],
            "scatterCountFS": 0,
            "xWaysSizes": [[1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1]],
            "postSafeArea": [
                ["M2", "M1", "L2", "L3"],
                ["M3", "L2", "L3", "EB"],
                ["L1", "M2", "SC", "EB"],
                ["L2", "M1", "L4", "EB"],
                ["M2", "M3", "L3", "EB"],
                ["L1", "L2", "M4", "L1"]
            ],
            "consecutiveAvalanches": 0,
            "waysWonTotalSpin": 0,
            "isExtraSpin": false
        }

    }

    public init(): Promise<NolimitPlugin> {
        return super.init().then((value: NolimitPlugin) => {
            HTH.model = new HTHModel(SlotGame.apiPlugin, true);
            HTH.gameFlowController = new GameFlowController(SlotGame.apiPlugin, HTH.model);
            HTH.gameFlowController.flowStateLogger.level = LogLevel.DEV;

            //Example
            HTH.model.events?.on(GameModelEvent.GAME, (data: IHTHGameData) => {
                console.log(data);
            });
            HTH.apiPlugin.events.once(APIEvent.RTP, (data: any) => {
                HTH.rtpData = data;
            });

            const winPres = new HTHWinPresentation();
            const normalIdle = new HTHNormalIdlePresentation();
            const avalancheIdle = new HTHAvalancheIdlePresentation();
            const reelStart = new HTHNormalBetPresentation();
            const normalResult = new HTHNormalResultPresentation();
            const zeroBetIdle = new HTHZeroBetIdlePresentation();
            const extraSpinIdle = new HTHExtraSpinIdle();

            HTH.gameFlowController.addGameModeFlowStatePresentationMap(HTHGameMode.NORMAL, new Map<FlowState, FlowStatePresentation>([[FlowState.IDLE, normalIdle], [FlowState.BET, reelStart], [FlowState.RESULT, normalResult], [FlowState.WIN, winPres]]));

            HTH.gameFlowController.addGameModeFlowStatePresentationMap(HTHGameMode.NORMAL_AVALANCHE, new Map<FlowState, FlowStatePresentation>([[FlowState.IDLE, avalancheIdle], [FlowState.RESULT, normalResult], [FlowState.WIN, winPres]]));

            HTH.gameFlowController.addGameModeFlowStatePresentationMap(HTHGameMode.FREESPIN, new Map<FlowState, FlowStatePresentation>([[FlowState.IDLE, zeroBetIdle], [FlowState.RESULT, normalResult], [FlowState.WIN, winPres]]));

            HTH.gameFlowController.addGameModeFlowStatePresentationMap(HTHGameMode.FREESPIN_AVALANCHE, new Map<FlowState, FlowStatePresentation>([[FlowState.IDLE, avalancheIdle], [FlowState.RESULT, normalResult], [FlowState.WIN, winPres]]));

            HTH.gameFlowController.addGameModeFlowStatePresentationMap(HTHGameMode.EXTRA_SPIN, new Map<FlowState, FlowStatePresentation>([[FlowState.IDLE, extraSpinIdle], [FlowState.RESULT, {start: (flowStateController: FlowStateController) => flowStateController.finish()}], [FlowState.WIN, {start: (flowStateController: FlowStateController) => flowStateController.finish()}],]));


            if (HTH.apiPlugin.gameClientConfiguration.isSet) {
                if (HTH.apiPlugin.gameClientConfiguration.sweepGfx) {
                    this.skinner.skinId = "sweep";
                }
            } else {
                HTH.apiPlugin.events.on(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => {
                    if (HTH.apiPlugin.gameClientConfiguration.sweepGfx
                    ) {
                        this.skinner.skinId = "sweep";
                    }
                })
            }

            return value;
        });
    }

    public getReady(): Promise<NolimitPlugin> {
        //Show intro and load game assets
        return super.getReady().then((value: NolimitPlugin) => {

            const fontLoader = new FontLoader(NolimitApplication.resourcePath);
            fontLoader.add(OpenSans.ITALIC_600);
            fontLoader.add(OpenSans.NORMAL_300);
            fontLoader.add(OpenSans.NORMAL_400);
            fontLoader.add(OpenSans.NORMAL_700);

            AssetsConfig.addToAssetsConfig(HTHGameAssets.RESOURCES_GROUPS);
            HTH.assetLoader = new AssetLoader(HTH.apiPlugin, NolimitApplication.resourcePath + "/resources/");

            const promises = Promise.all([fontLoader.load(), HTH.assetLoader.load(ResourcesGroupName.MAIN)]);

            return promises.then((values: any) => {

                this.createViewsAndComponents();

                RestoreUtils.startUpGame(HTH.model.data.isRestoreState, false);

                if (this.skinner.skinId != undefined) {
                    const replaceMap: Map<string, string> = new Map();

                    //Bonus
                    replaceMap.set("BOOSTED_BET", "BOOSTED_BET.png");
                    this.skinner.loadSkin(replaceMap);
                }

                return value;
            });
        });
    }

    public getReadyToStart(): Promise<NolimitPlugin> {
        //Game assets loaded, waiting for user to start game.
        return super.getReadyToStart().then((value: NolimitPlugin) => {
            HTHSound.switchMusic({name: HTHSound.MAIN_GAME_MUSIC});
            return value;
        });
    }

    public start(): Promise<NolimitPlugin> {
        //User has pressed continue and the game starts.
        return super.start().then((value: NolimitPlugin) => {
            (<any>NolimitApplication.pixiApp.renderer.mask).enableScissor = true;
            HTHSound.playTrack(HTHSound.CONTINUE_BUTTON);
            HTH.gameFlowController.start();
            if ((HTH.model.mode === HTHGameMode.FREESPIN || HTH.model.mode === HTHGameMode.FREESPIN_AVALANCHE) && (HTH.model.nextMode === HTHGameMode.FREESPIN || HTH.model.nextMode === HTHGameMode.FREESPIN_AVALANCHE)) {
                HTHSound.playSFSMusic(HTH.model.safeSymbols);
            }
            if (!HTH.model.isRestore) {
                if (!HTH.apiPlugin.isReplay) {
                    // HTH.gameIntroView.startIntro();
                }
            }
            return value;
        });
    }

    private createViewsAndComponents() {
        //Non views
        HTH.soundPlayer = new HTHSound();
        HTH.extraSpinBet = new ExtraSpinView();

        //Static views
        HTH.fsGainedView = new FSGainedView();
        HTH.backgroundElements = new HTHBackgroundElements();
        HTH.backgroundElements.startMode(HTH.model.data.nextMode);
        HTH.symbolAnimation = new HTHSymbolAnimation();
        HTH.symbolOverlay = new HTHSymbolOverlay();
        HTH.additionalLayers = new AdditionalLayers();
        HTH.reelArea = new HTHReelArea();
        HTH.individualWinTextView = new HTHIndividualWinTextView();
        HTH.gameViewContainer = new HTHGameView();
        HTH.totalWinView = new HTHTotalWinView();
        HTH.bigWinView = new HTHBigWinView();
        HTH.fsIntroView = new HTHFSIntro();
        HTH.fsOutroView = new HTHFSOutro();
        HTH.reelAnticipation = new HTHReelAnticipation();
        HTH.reelAnticipationTop = new HTHReelAnticipationTop();
        HTH.winCapView = new HTHWinCap();
        HTH.transitionView = new TransitionScreen();
        HTH.miniPayTable = new MiniPayTable(HTH.model.initData.symbolValues);
        HTH.screenInteractive = new ScreenInteractiveLayer();
        HTH.gameIntroView = new HTHGameIntroView();

        HTH.gameViewContainer.addChild(HTH.backgroundElements);
        HTH.gameViewContainer.addChild(new ReelFrameElements());
        HTH.gameViewContainer.addChild(HTH.reelAnticipation);
        HTH.gameViewContainer.addChild(HTH.reelArea);
        HTH.gameViewContainer.addChild(HTH.reelAnticipationTop);
        HTH.gameViewContainer.addChild(HTH.symbolAnimation);
        HTH.gameViewContainer.addChild(HTH.symbolOverlay);
        HTH.gameViewContainer.addChild(HTH.additionalLayers);


        HTH.gameViewContainer.addChild(HTH.individualWinTextView);
        HTH.gameViewContainer.correctLayering();

        NolimitApplication.addLayerAt(HTH.fsGainedView.name, HTH.fsGainedView, 0);
        NolimitApplication.addLayerAt(HTH.screenInteractive.name, HTH.screenInteractive, 0);
        NolimitApplication.addLayerAt(HTH.extraSpinBet.name, HTH.extraSpinBet, 0);
        NolimitApplication.addLayerAt(HTH.gameViewContainer.name, HTH.gameViewContainer, 0);
        NolimitApplication.addLayerAt(HTH.miniPayTable.name, HTH.miniPayTable, 1);
        NolimitApplication.addLayerAt(HTH.totalWinView.name, HTH.totalWinView, 2);
        NolimitApplication.addLayerAt(HTH.bigWinView.name, HTH.bigWinView, 3);
        NolimitApplication.addLayerAt(HTH.fsIntroView.name, HTH.fsIntroView, 4);
        NolimitApplication.addLayerAt(HTH.fsOutroView.name, HTH.fsOutroView, 5);
        NolimitApplication.addLayerAt(HTH.winCapView.name, HTH.winCapView, 6);
        NolimitApplication.addLayerAt(HTH.transitionView.name, HTH.transitionView, 7);
        // NolimitApplication.addLayerAt(HTH.gameIntroView.name, HTH.gameIntroView, 8);

        if (NolimitConfig.isDevMode) {
            if (NolimitApplication.isLandscape) {
                SpineViewUtils.init(HTHGameAssets.RESOURCES_GROUPS.main, HTH.assetLoader);
            }
            NolimitApplication.addLayer("Speedster", new Speedster());
        }


    }
}